import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { FormGroup, FormControl, AbstractControl } from '@angular/forms';
//import { GridOptions } from '@ag-grid-enterprise/all-modules';
import { GridOptions } from 'ag-grid-community';
import { debounceTime } from 'rxjs/operators';

@Component({
    selector: 'grid-option-config',
    templateUrl: './grid-option-config.component.html',
    styleUrls: ['./grid-option-config.component.scss'],
    standalone: false
})
export class GridOptionConfigComponent implements OnInit, OnDestroy {
    @Input()
    componentConfig: any;
    form: FormGroup = this.createFormGroupFromConfig();
    rowSelectionTypes = RowSelection;

    constructor(
    ) { }

    ngOnInit() {
        this.form = this.createFormGroupFromConfig();

        this.form.valueChanges.pipe(debounceTime(200)).subscribe((result) => {
            this.createConfigFromForm();
        });
    }

    ngOnDestroy() {
        this.createConfigFromForm();
    }

    createFormGroupFromConfig(): FormGroup {
        if (!this.componentConfig || !this.componentConfig.gridOptions)
            return new FormGroup(this.defaultConfig());

        let def = this.defaultConfig();
        let obj: { [key: string]: AbstractControl } = {};

        for (let prop in this.componentConfig.gridOptions)
            obj[prop] = new FormControl(this.componentConfig.gridOptions[prop]);

        for (let prop in def)
            if (!obj[prop])
                obj[prop] = def[prop];

        let form = new FormGroup(obj);
        let ctrl = form.controls.rowSelection;
        let value: string = ctrl.value;
        let str = `${value.charAt(0).toUpperCase()}${value.substr(1)}`;
        ctrl.setValue(str);

        return form;
    }

    createConfigFromForm() {
        let gridOptions: GridOptions = {};

        for (let ctrlName in this.form.controls)
            gridOptions[ctrlName] = this.form.get(ctrlName).value;

		gridOptions.rowSelection = gridOptions.rowSelection;//.toLocaleLowerCase();
        this.componentConfig.gridOptions = gridOptions;
    }

    defaultConfig(): { [key: string]: AbstractControl } {
        return {
            suppressDragLeaveHidesColumns: new FormControl(true),
            rowSelection: new FormControl(RowSelection.Single),
            rowMultiSelectWithClick: new FormControl(false),
            enableSorting: new FormControl(true),
            enableFilter: new FormControl(true),
            enableColResize: new FormControl(true)
        };
    }
}

export enum RowSelection {
    Single = 'Single',
    Multiple = 'Multiple'
}
